import { render, staticRenderFns } from "./ModalEditTranslation.vue?vue&type=template&id=a3182fb8&"
import script from "./ModalEditTranslation.vue?vue&type=script&lang=js&"
export * from "./ModalEditTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports